var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{attrs:{"name":"supplier","rules":{
    required: _vm.requiredField,
  }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var errors = ref.errors;
return [_c('b-form-group',{attrs:{"label":"Fornecedor","label-for":"supplier"}},[_c('vue-autosuggest',{class:errors.length > 0 ? 'error-select' : '',attrs:{"no-filter":"","suggestions":_vm.suppliersOptions,"input-props":{
        id: 'supplier',
        ref: 'supplier',
        class: errors.length > 0 ? 'form-control is-invalid' : 'form-control',
        placeholder: _vm.readonly ? '' : 'Fornecedor',
        readonly: _vm.readonly,
      },"limit":_vm.limitElements,"get-suggestion-value":_vm.getSupplierSelected},on:{"input":_vm.onInputSupplierChange,"selected":_vm.onSelectedSupplier,"blur":_vm.onBlur},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var suggestion = ref.suggestion;
return [_c('p',[_vm._v(_vm._s(suggestion.item.name))])]}}],null,true),model:{value:(_vm.supplierSearch),callback:function ($$v) {_vm.supplierSearch=$$v},expression:"supplierSearch"}}),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(errors[0]))])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }